// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__2RXHf","footer":"ReportModalFilter_footer__1F2g6"};